import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-audioContent",
  "use": "icon-audioContent-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"icon-audioContent\"><path d=\"M921.6 1024H853.333333a102.4 102.4 0 0 1-102.4-102.4v-204.8a102.4 102.4 0 0 1 102.4-102.4h15.758223c11.662222 0.113778 23.210667 2.275556 34.133333 6.257778V512c0-245.077333-146.204444-391.224889-391.224889-391.224889-245.077333 0-391.224889 146.204444-391.224889 391.224889v108.657778c10.922667-3.982222 22.471111-6.144 34.133333-6.257778H170.666667a102.4 102.4 0 0 1 102.4 102.4v204.8A102.4 102.4 0 0 1 170.666667 1024H102.4A102.4 102.4 0 0 1 0 921.6V512a512 512 0 1 1 1024 0v409.6a102.4 102.4 0 0 1-102.4 102.4z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/audioContent.svg
// module id = 0kwC
// module chunks = 78